// Property-address helpers (ticket 75).
//
// Opportunities historically stored `property_address` as a free-text string;
// loan files and RE transactions store a structured Address
// ({street, unit, city, state, zip}). Both shapes are live, so every renderer
// goes through addressLine() and every form submits through addressPayload().

export const ADDRESS_PARTS = ['street', 'unit', 'city', 'state', 'zip'];

export const emptyAddress = () => ({ street: '', unit: '', city: '', state: '', zip: '' });

export function hasAddress(a) {
  if (!a) return false;
  if (typeof a === 'string') return a.trim().length > 0;
  return ADDRESS_PARTS.some((k) => (a[k] || '').trim().length > 0);
}

// Object → trimmed object, or null when every part is blank.
export function addressPayload(a) {
  if (!hasAddress(a)) return null;
  if (typeof a === 'string') return a.trim();
  const out = {};
  ADDRESS_PARTS.forEach((k) => { const v = (a[k] || '').trim(); if (v) out[k] = v; });
  return out;
}

// One-line rendering for a string or an Address; null when blank.
export function addressLine(a) {
  if (!a) return null;
  if (typeof a === 'string') return a.trim() || null;
  const head = [a.street, a.unit, a.city].filter(Boolean).join(', ');
  const tail = [a.state, a.zip].filter(Boolean).join(' ');
  return [head, tail].filter(Boolean).join(', ') || null;
}
